import CoverageNonLiabilityLinkModal from '@root/quotes/src/components/modals/coverage-non-liability-link-modal';
import PropTypes from '@root/vendor/prop-types';
import React from '@root/vendor/react';
import { StyleSheet, Theme } from '@root/core/src/utils/styles';

const NjPipMedicalExpensesLearnMoreModal = ({
  primaryBrandColor,
  infoBrandColor,
}) => (
  <CoverageNonLiabilityLinkModal
    infoBrandColor={infoBrandColor}
    linkText={'Learn more'}
    modalName={'NJ PIP Medical Expenses Learn More Modal'}
    primaryBrandColor={primaryBrandColor}
  >
    <h2 css={styles.header}>Medical Expenses</h2>
    <p css={styles.paragraph}>This helps pay medical bills after an accident, regardless of who was at fault. You must have this coverage in your state, but you choose your:</p>
    <ul css={styles.list}>
      <li css={styles.listItem}><strong>Limit</strong>: The max amount Root pays out.</li>
      <li css={styles.listItem}><strong>Deductible</strong>: how much you pay first before anything is covered.</li>
    </ul>
  </CoverageNonLiabilityLinkModal>
);

NjPipMedicalExpensesLearnMoreModal.propTypes = {
  infoBrandColor: PropTypes.string,
  primaryBrandColor: PropTypes.string,
};

export default NjPipMedicalExpensesLearnMoreModal;

const styles = StyleSheet.create({
  header: {
    ...Theme.heading2(),
    marginBottom: 24,
  },
  paragraph: {
    ...Theme.paragraph1(),
    marginBottom: 12,
  },
  list: {
    listStyleType: 'disc',
    marginBottom: 12,
    paddingLeft: 24,
  },
  listItem: {
    marginBottom: 8,
  },
});
